import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import {Store} from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import * as fromCommonStore from '../../store';
import * as commonActions from '../../store/actions/common.actions';
import { AuthService } from '../../services/index';
import * as _ from 'lodash';

@Component({
    moduleId: module.id,
    templateUrl: 'login.component.html'
})

export class LoginComponent implements OnInit {
    user: any = {};
    loading = false;
    otpSection = false;
    otp: string[] = ['', '', '', ''];
    isOtpExpired: boolean = false; // Flag to disable OTP after time limit
    countdown: number = 120; // Time limit in seconds for 2 minutes (120 seconds)
    displayTime: string = '02:00'; // For displaying time in MM:SS format
    timer: any; // For storing the setInterval reference
    resendDisabled: boolean = true;
    visibleOtp: boolean = false;
    returnUrl: string;
    isLoadMask: Promise<any>;
    errorMsg: string;
    ipAddress:any;
    otpCheck:any;
    //branchList = [];
    constructor(
        private store: Store<fromCommonStore.State>,
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService,
        public toasterService: ToasterService) { }

    ngOnInit() {
        /*let that = this;
        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res)) {
                //this.store.dispatch(new commonActions.LoadAllBranch());
                //this.branchList$ = res;
                return;
            }
            that.branchList = res.data;
        });*/
        // this.getIP();
        setTimeout(()=>{
            $('#username').focus();
        },100);
    }

     getIP()
    {
      this.authService.getIPAddress().subscribe((res:any)=>{
        let obj = JSON.parse(res._body);
             this.ipAddress =obj.IPv4;
             return this.ipAddress;
      });
    }

    onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }

    onKeyUp(index: number, event: KeyboardEvent) {
        // Move to the next box on input (ensure the input is a valid character)
        if (event.key.length === 1 && /\d/.test(event.key) && index < 3) {
            const nextInput = document.getElementById(`otp${index + 1}`);
            if (nextInput) {
                (nextInput as HTMLInputElement).focus();
            }
        }
        
        // Move back to the previous box on backspace (only if the current box is empty)
        if (event.key === 'Backspace' && index > 0 && !this.otp[index]) {
            const prevInput = document.getElementById(`otp${index - 1}`);
            if (prevInput) {
                (prevInput as HTMLInputElement).focus();
            }
        }
    }
    

    startCountdown() {
        this.countdown = 120; // Reset countdown to 2 minutes (120 seconds)
        this.isOtpExpired = false; // Enable OTP form
        this.updateDisplayTime(); // Update initial display time
        this.timer = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown--; // Decrement the countdown
            this.updateDisplayTime(); // Update the displayed time
          } else {
            this.isOtpExpired = true; // Disable OTP form when countdown reaches 0
            this.resendDisabled = false;
            clearInterval(this.timer); // Stop the timer
          }
        }, 1000); // Run every second
      }
    
      updateDisplayTime() {
        const minutes = Math.floor(this.countdown / 60);
        const seconds = this.countdown % 60;
        // Format the time as MM:SS
        this.displayTime = `${this.pad(minutes)}:${this.pad(seconds)}`;
      }
    
      pad(value: number): string {
        return value < 10 ? '0' + value : String(value); // Add leading zero if needed
      }
    
    generateOtp() {
        //ONE BROWSER ON TAB TO BE USED
        let params = {
            start: 0,
            limit: 1,
            username : this.user['username']
        };
        this.isLoadMask = this.authService
            .generateOtp(params)
            .then((res:any) =>{
                if(res.success){
                    // this.otpCheck = res.OTP.toString();
                    this.visibleOtp = true;
                    this.otpSection = true;
                    this.startCountdown();
                }else{
                    this.errorMsg = res.message;
                }
            })
            .catch((error: any) => {
                console.log(error);
            });
    }

    verifyOtp() {
        if (this.isOtpExpired) {
            this.errorMsg = 'Invalid OTP. Please try again.'
        }
        
        // let enteredOtp = this.otp.join('');
        // if (enteredOtp === this.otpCheck) {
            this.login();
        // } else {
        //     this.errorMsg = 'Invalid OTP. Please try again.';
        // }
    }

    resendOtp(){
        this.otp = ['', '', '', ''];
        this.generateOtp();
    }

    userVerify() {
        //ONE BROWSER ON TAB TO BE USED
        let tabID = sessionStorage.tabID ? sessionStorage.tabID : sessionStorage.tabID = Math.random();
        this.loading = true;
        let that = this;
        this.user['browserTabId'] = tabID;
        var data = this.ipAddress;
        this.user['ipAddress'] = data;
        this.isLoadMask = this.authService
            .userVerify(this.user,data)
            .then((res:any) =>{
                if(res.success){
                    if(res.data){
                        var ids = [res.id_1, res.id_2, res.id_3, res.id_4, res.id_5, res.id_6, res.id_7, res.id_8, res.id_9, res.id_10];
                        var currentIndex = 0;
                        // Function to try the next ID in the list
                        const tryNextID = () => {
                            if (currentIndex >= ids.length || !ids[currentIndex]) {
                                this.loading = false; // Stop loading
                                this.errorMsg = 'System IDs Verify Failed...';
                                return; // Exit the function
                            }

                            const systemID = ids[currentIndex];
                            this.authService.systemVerify(systemID)
                                .then((systemRes: any) => {
                                    if (systemRes.status == 200) {
                                        // this.loading = false;
                                        this.generateOtp();
                                        // this.login(); 
                                    } else {
                                        currentIndex++;  // Move to the next ID
                                        tryNextID(); // Try the next ID
                                    }
                                })
                                .catch(() => {
                                    currentIndex++;
                                    tryNextID(); // Try the next ID on error
                                });
                        };

                        tryNextID(); // Start trying IDs

                    //     this.isLoadMask = this.authService
                    //     .systemVerify(res.data)
                    //     .then((systemRes:any) =>{
                    //         if(systemRes.status == 200){
                    //             this.login();
                    //         }else{
                    //             this.errorMsg = 'system IDs Verify Failed...';
                    //         }
                    //     })
                    //     .catch((error: any) => {
                    //         this.errorMsg = 'system IDs Verify Failed...';
                    //         console.log(error);
                    //     });
                    } else {
                        this.login();
                        // this.generateOtp();
                    }
                }else{
                    this.errorMsg = res.message;
                }
            })
            .catch((error: any) => {
                this.errorMsg = 'system IDs Verify Failed...';
                console.log(error);
            });
    }

    login() {
        //ONE BROWSER ON TAB TO BE USED
        let tabID = sessionStorage.tabID ? sessionStorage.tabID : sessionStorage.tabID = Math.random();
        this.loading = true;
           
        let that = this;
        this.user['browserTabId'] = tabID;
        var data = this.ipAddress;
        this.user['ipAddress'] = data;
        this.user['otp'] = this.otp.join('');
        this.isLoadMask = this.authService
            .login(this.user,data)
            .then((res:any) =>{
                if(res.success){
                    this.store.dispatch(new commonActions.IsAuth(true));
                    //localStorage.setItem('currentUser', 'Abdul');
                    clearInterval(this.timer); // Stop the timer after verification
                    this.router.navigate([''], {skipLocationChange: true});
                }else{
                    this.errorMsg = res.message;
                }
            })
            .catch((error: any) => {
                console.log(error);
            });
    }


    loginVerification() {
        
        //ONE BROWSER ON TAB TO BE USED
        let tabID = sessionStorage.tabID ? sessionStorage.tabID : sessionStorage.tabID = Math.random();
        this.loading = true;
           
        let that = this;
        this.user['browserTabId'] = tabID;
        var data = this.ipAddress;
        this.user['ipAddress'] = data;
        this.user['otp'] = this.otp.join('');
        this.isLoadMask = this.authService
            .loginVerification(this.user,data)
            .then((res:any) =>{
                if(res.success){
                    this.errorMsg = '';
                    this.userVerify();
                }else{
                    this.errorMsg = res.message;
                }
            })
            .catch((error: any) => {
                console.log(error);
            });
    }
    
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/login/login.component.ts